const CART_SUMMARY_REFRESH_MS = 300;

let refreshTimeoutId;
let pendingSlug;

export const scheduleQuickOrderCartSummaryRefresh = (
  dispatch,
  slug,
  getCartDataSummary
) => {
  pendingSlug = slug;
  window.clearTimeout(refreshTimeoutId);
  refreshTimeoutId = window.setTimeout(() => {
    dispatch(getCartDataSummary({ slug: pendingSlug }));
  }, CART_SUMMARY_REFRESH_MS);
};
